import { useEffect, useState } from "react";

export function useServiceWorkerUpdate() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      console.log("[SW] Not supported");
      return;
    }

    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // Case 1: A new SW is already waiting when the page loads
        if (registration.waiting) {
          setWaitingWorker(registration.waiting);
          setNewVersionAvailable(true);
        }

        // Case 2: Listen for new SW found while user is on the page
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              setWaitingWorker(newWorker);
              setNewVersionAvailable(true);
            }
          });
        });

        // Case 3: Check when user returns to tab (replaces 20s polling)  ✅ CHANGED
        const triggerUpdate = () => registration.update();

        window.addEventListener("focus", triggerUpdate);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") triggerUpdate();
        });

        return () => {
          window.removeEventListener("focus", triggerUpdate);
          document.removeEventListener("visibilitychange", triggerUpdate);
        };
      })
      .catch((err) => {
        console.error("[SW] Registration failed:", err);
      });
  }, []);

  // ✅ No changes below this line
  const updateNow = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      console.log("[SW] No waiting worker, reloading anyway...");
      window.location.reload();
    }
  };

  return { newVersionAvailable, updateNow };
}
